import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { stripe } from '@/config';
import { supportedCountries } from '@/constants/locale/countries';
import { useMemo } from 'react';

type StripeElementLocale = NonNullable<
    React.ComponentProps<typeof Elements>['options']
>['locale'];

export default function StripeElements({
    children,
    countryCode,
}: {
    children: React.ReactNode;
    countryCode: string;
}): JSX.Element {
    const country =
        supportedCountries.find((country) => country.value === countryCode) ??
        supportedCountries[0];

    const stripePromise = useMemo(
        () =>
            loadStripe(`${country.value === 'US' ? stripe.keyUS : stripe.key}`),
        [country],
    );

    return (
        <Elements
            stripe={stripePromise}
            options={{ locale: country.slug as StripeElementLocale }}>
            {children}
        </Elements>
    );
}
